// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3USXs","inner":"Footer_inner__3eXBU","nextIcon":"Footer_nextIcon__2apPc","innerLeft":"Footer_innerLeft__1nvrV"};